import * as Scrivito from "scrivito";
import metadataAttributes from "../_metadataAttributes";
import defaultPageAttributes from "../_defaultPageAttributes";

const SearchResults = Scrivito.provideObjClass("SearchResults", {
  attributes: {
    ...defaultPageAttributes,
    navigationBackgroundImage: ["reference", { only: ["Image"] }],
    ...metadataAttributes,
  },
});

export default SearchResults;
